




































































































































































import { Component, Vue } from 'vue-property-decorator'
import { AutoCloseSettings } from '@/api/model/auto-close-settings'
import { CompanyAPI, PipelineAPI } from '@/api/backend-client'
import { Pipeline } from '@/api/model/pipeline'
import PipelineLabel from '@/components/label/PipelineLabel.vue'
import InputSwitch from '@/components/input/InputSwitch.vue'
import IconWarning from '@/components/icons/IconWarning.vue'
import IconInfoCircle from '@/components/icons/IconInfoCircle.vue'

@Component({
    components: {
        IconInfoCircle,
        IconWarning,
        InputSwitch,
        PipelineLabel},
})
export default class AutoClose extends Vue {
    loading: boolean = false
    autoCloseSettings: AutoCloseSettings = null
    pipelines: Pipeline[] = []

    defaultDays = 120

    async mounted(): Promise<void> {
        await this.loadContent()
    }

    async loadContent(): Promise<void> {
        this.loading = true
        this.autoCloseSettings = await CompanyAPI.getAutoCloseSettings(this.$currentCompany.id)
        this.pipelines = await PipelineAPI.getOwnPipelines()
        this.pipelines.sort((a, b) => a.name.localeCompare(b.name))
        this.autoCloseSettings = this.autoCloseSettings ?? AutoCloseSettings.new(this.$currentCompany.id)
        this.loading = false
    }

    async save(): Promise<void> {
        this.loading = true
        const promises = []

        this.pipelines.forEach(pipeline => {
            if (!this.autoCloseSettings.perPipelineEnabled) {
                pipeline.autoCloseAfterDays = null
            }

            promises.push(PipelineAPI.update(pipeline.id, pipeline))
        })

        await Promise.any(promises)

        const autoCloseSettings = await CompanyAPI.updateAutoCloseSettings(this.$currentCompany.id, this.autoCloseSettings)
        this.$set(this.$currentCompany, 'autoCloseSettings', autoCloseSettings)
        this.$notify({
            group: 'information',
            type: 'success',
            title: this.$t('company_settings.auto_close.success.title').toString(),
            text: this.$t('company_settings.auto_close.success.message').toString(),
        })
        this.loading = false
    }

    get minCloseAfterDays() {
        return 14
    }

    get minNotificationBeforeDays() {
        return 1
    }

    get maxNotificationBeforeDays() {
        if (this.autoCloseSettings.closeAfterDays === null) {
            return Number.MAX_SAFE_INTEGER
        }

        return this.autoCloseSettings.closeAfterDays
    }

    get autoCloseIntroText() {
        return this.$t('company_settings.auto_close.intro', { name: this.$currentCompany.virtualColleagueName })
    }

    get closeAfterDaysText() {
        return this.$t(`company_settings.auto_close.closeAfterDays.text`, { name: this.$currentCompany.virtualColleagueName })
    }

    get avatarName() {
        return this.$currentCompany.virtualColleagueName
    }
}
